import { getUserById, getSelectList, getList, getOne } from './getData'
import {
  setCreate,
  setUpdate,
  setDelete,
  lostPassword,
  resetPassword
} from './setData'

const users = {
  namespaced: true,
  state: {
    listaUsers: [],
    loading: false,
    listSelectUsers: [],
    idSelected: '',
    userSelected: {}
  },
  mutations: {
    updateList: (state, list) => {
      state.listaUsers = list
        ? list.map(user => ({
            ...user,
            photo: `${process.env.VUE_APP_IMAGE_URL}${user.photo}`
          }))
        : []
    },
    updateSelectList: (state, list) => {
      state.listSelectUsers = []
      if (Array.isArray(list)) {
        list.forEach(item => state.listSelectUsers.push(item))
      }
    },
    updateOneToList: (state, user) => {
      if (user) {
        let searchList = state.listaUsers.find(item => item._id === user._id)
        if (!searchList) {
          state.listaUsers.push(user)
        }
        searchList = state.listSelectUsers.find(item => item.value === user._id)
        if (!searchList) {
          state.listSelectUsers.push({
            text: user.name + ' ' + user.lastname1,
            value: user._id,
            photo: `${process.env.VUE_APP_IMAGE_URL}${user.photo}`
          })
        }
      }
    },
    updateOne: (state, one) => {
      state.userSelected = one
        ? { ...one, photo: `${process.env.VUE_APP_IMAGE_URL}${one.photo}` }
        : {}
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => (state.loading = loading),
    updateClearOne: state => {
      state.userSelected = {}
      state.idSelected = ''
    }
  },
  actions: {
    async setSearch({ commit, state }, id) {
      const user = state.listaUsers.find(item => item._id === id)
      if (!user) await getUserById(commit, id)
    },
    setInit: ({ commit }) => getList(commit),
    setInitSelect: (context, payload = {}) => getSelectList(context, payload),
    setCreateNew: async ({ commit }, user) => {
      await setCreate(user)
      getList(commit)
    },
    setUpdateUser: async ({ commit }, user) => {
      await setUpdate(user)
      getList(commit)
    },
    setDeleteUser: async ({ commit }, id) => {
      await setDelete(id)
      getList(commit)
    },
    setOne: async ({ commit }, id) => {
      await getOne(commit, id)
    },
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    },
    lostPassword: async ({ commit }, email) => {
      await lostPassword(email)
    },
    resetPassword: async ({ commit }, { tk, userId, newPassword }) => {
      await resetPassword(tk, userId, newPassword)
    }
  }
}

export default users
